import { styled } from "@mui/system";
import Box from "@mui/material/Box";

import { colors, others } from "../colors";

export const FadedContainedButtonUI = () => ({
  backgroundColor: colors.backgrounds[3],
  color: colors.fonts[18],
  height: "1.7rem",
  fontSize: ".7rem",
  fontWeight: 600,
  boxShadow: "none",
  "&:hover": {
    backgroundColor: colors.backgrounds[3],
    color: colors.fonts[18],
    boxShadow: "none",
  },
});

export const ScrollLock = () => {
  return {
    disableScrollLock: true,
  };
};

export const RouteBox = styled(Box)(() => ({
  maxWidth: "none",
  margin: "0 auto",
  width: "100%",
}));

export const NppesFadedContainedButtonUI = () => ({
  backgroundColor: colors.backgrounds[3],
  color: colors.black[4],
  height: "1.7rem",
  fontSize: ".7rem",
  fontWeight: 600,
  boxShadow: "none",
  "&:hover": {
    backgroundColor: colors.backgrounds[3],
    color: colors.fonts[18],
    boxShadow: "none",
  },
});

export const tableHederCellStyle = {
  paddingTop: "0.625rem",
  borderBottom: "none",
};
export const NppesNPIPadding = {
  padding: "0.5rem",
};
export const NppesNPISearchPadding = {
  padding: "0 0 0.5rem 0.5rem",
};

export const NppesTableHeadColor = {
  backgroundColor: others.MainBackground[1],
};

export const NppesinlineStyle = {
  width: "100%",
  marginTop: "0.4rem",
  height: "auto",
  position: "sticky",
  top: "auto",
};
